import PropTypes from 'prop-types';

import { ProfileHeader } from '#client/components/ProfileHeader';

import { useEnterpriseProfileHeader } from './hooks/useEnterpriseProfileHeader';

function EnterpriseProfileHeader({ enterprise }) {
  const {
    formationDate,
    hasError,
    loading,
    name,
    nameInitials,
    statusItems
  } = useEnterpriseProfileHeader({ enterprise });

  return (
    <ProfileHeader
      formationDate={formationDate}
      hasError={hasError}
      loading={loading}
      name={name}
      nameInitials={nameInitials}
      statusItems={statusItems}
    />
  );
}

EnterpriseProfileHeader.propTypes = {
  enterprise: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
  }).isRequired
};

export default EnterpriseProfileHeader;
